import {
  Box,
  Button,
  Grid,
  Group,
  LoadingOverlay,
  NumberInput,
  Select,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck, IconWindow } from "@tabler/icons-react";
import { repositoryPos } from "../../_base/_const/_constVar";
import { MessageResponse } from "../../model/MessageResponse";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import { sky_blue } from "../../const/variables";
import { useEffect, useState } from "react";
import { getTblDmCustomerGroupSelect } from "../../service/getSelectApi";

const EditDataView = ({ id, type, onClose }: EditDataViewProps) => {
  const entity = {
    id: "0",
    groupCode: null,
    groupName: null,
    taxCode: null,
    address: null,
    phone: null,
    contactPerson: null,
    classification: null,
    classificationName: null,
    debtTerm: null,
    debtLimit: null,
    type: null,
    typeName: null,
    createBy: null,
    createByName: null,
    lastUpdateBy: null,
    lastCreateByName: null,
    lastUpdateDate: null,
    createDate: null,
  };

  const [dataTblCustomerGroup, setDataTblCustomerGroup] = useState<
    { value: string; label: string; att1: string }[]
  >([]);

  const [visible, { toggle, close, open }] = useDisclosure(false);
  const form = useForm<any>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },

    validate: {},
  });

  const callApiGetData = async () => {
    open();
    const callApi = await repositoryPos.get<MessageResponse<any>>(
      `/api/v1/TblDebtGroup/edit?id=${id}`
    );
    if (callApi?.success) {
      const dataApi = callApi?.data;
      if (dataApi !== null) {
        form.setValues(dataApi);
        form.resetDirty(dataApi);
      }
      close();
    } else {
      onClose("");
    }
  };

  const dataCustomerGroupSelect = async () => {
    try {
      const getData = await getTblDmCustomerGroupSelect();
      const filteredData = getData?.filter(
        (item) => item.value != null && item.text != null
      );
      const mappedData = filteredData?.map((item) => ({
        value: item.value,
        label: item.text,
        att1: item.att1,
      }));
      setDataTblCustomerGroup(mappedData);
    } catch (error) {
      console.error("Error in dataTblLocation: ", error);
    }
  };

  const handleEditTblDebtGroup = async (dataSubmit: any) => {
    open();
    const dataApi = await repositoryPos.post<MessageResponse<any>>(
      "/api/v1/TblDebtGroup/edit",
      { ...dataSubmit, type: type }
    );
    if (dataApi?.success) {
      NotificationExtension.Success("Cập nhật thành công !");
      onClose((prev: any) => !prev);
      modals.closeAll();
    }
    close();
  };

  useEffect(() => {
    if (id) callApiGetData();
  }, [id]);

  useEffect(() => {
    dataCustomerGroupSelect();
  }, []);

  return (
    <>
      <Box
        component="form"
        mx="auto"
        w={{
          base: "300px",
          xs: "400px",
          sm: "500px",
          md: "650px",
          lg: "700px",
        }}
        onSubmit={form.onSubmit((e: any) => {
          handleEditTblDebtGroup(e);
        })}
        style={{ position: "relative" }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />

        <Grid mt={10}>
          <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
            <TextInput
              disabled
              withAsterisk
              label={"Mã nhóm công nợ"}
              placeholder={"Nhập mã nhóm công nợ"}
              {...form.getInputProps("groupCode")}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
            <TextInput
              withAsterisk
              label={"Tên nhóm công nợ"}
              placeholder={"Nhập tên nhóm công nợ"}
              {...form.getInputProps("groupName")}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
            <TextInput
              disabled
              label={"Mã số thuế"}
              placeholder={"Nhập mã số thuế"}
              {...form.getInputProps("taxCode")}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
            <TextInput
              label={"Người giao dịch"}
              placeholder={"Nhập tên người giao dịch"}
              {...form.getInputProps("contactPerson")}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
            <TextInput
              label={"Điện thoại"}
              placeholder={"Nhập số điện thoại"}
              {...form.getInputProps("phone")}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
            <TextInput
              label={"Địa chỉ"}
              placeholder={"Nhập địa chỉ"}
              {...form.getInputProps("address")}
            />
          </Grid.Col>
          {/* <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
            <TextInput
              disabled
              label={"Loại KH"}
              placeholder={"Nhập Loại KH"}
              {...form.getInputProps("classification")}
            />
          </Grid.Col> */}
          {/* <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
            <Select
              label={"Nhóm khách hàng"}
              placeholder={"Chọn nhóm khách hàng"}
              withAsterisk={form.getValues().type?.toString() !== "1"}
              searchable
              clearable
              disabled={form.getValues().type?.toString() === "2"}
              value={form.getValues().classificationName?.toString() ?? null}
              data={dataTblCustomerGroup.filter(
                (value: any) =>
                  value?.att1 === form?.getValues().type?.toString()
              )}
              {...form.getInputProps("classificationName")}
              onChange={(value) => {
                form.setValues((prev) => ({
                  ...prev,
                  classificationName: value?.toString(),
                }));
              }}
            />
          </Grid.Col> */}
          <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
            <NumberInput
              label={"Thời hạn nợ"}
              placeholder={"Nhập thời hạn nợ"}
              value={Number(form.getValues()?.debtTerm)}
              {...form.getInputProps("debtTerm")}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
            <NumberInput
              thousandSeparator=","
              hideControls
              label={"Giới hạn nợ"}
              placeholder={"Nhập giới hạn nợ"}
              value={Number(form.getValues()?.debtLimit)}
              {...form.getInputProps("debtLimit")}
            />
          </Grid.Col>
        </Grid>

        <Group
          justify="end"
          mt="xs"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button
            type="button"
            color="gray"
            loading={visible}
            onClick={() => {
              modals.closeAll();
            }}
            leftSection={!visible ? <IconWindow size={18} /> : undefined}
          >
            Đóng
          </Button>
          <Button
            type="submit"
            color={sky_blue.base}
            loading={visible}
            leftSection={!visible ? <IconCheck size={18} /> : undefined}
          >
            Lưu
          </Button>
          <></>
        </Group>
      </Box>
    </>
  );
};

export default EditDataView;

type EditDataViewProps = {
  id: string | number;
  onClose: any;
  type: number;
};
